export const FORMS_KEYS = {
  budget: 'budget',
  deconForm: 'deconForm',
  pickupForm: 'pickupForm',
  recipientForm: 'recipientForm',
  summary: 'summary'
};

export default { FORMS_KEYS };
